<template>
  <v-card class="mx-auto mt-10 pl-4 pr-4 pt-10 pb-10"
          outlined
          max-width="1000">
    <h2 class="text-center mb-4">{{ 'Contact System Admin' }}</h2>
    <span>Got a problem that need support? Please contact your admin via phone or email:</span>
    <div style="padding-left: 132px;" class="mt-10">
<!--      <div class="d-flex  mb-4">-->
<!--          <span class="font-weight-bold text-left mr-6" style="    min-width: 100px;">-->
<!--            {{ 'Contact name' }}-->
<!--          </span>-->
<!--        <span>-->
<!--          {{ contactAdmin.display_name || '' }}-->
<!--          </span>-->
<!--      </div>-->
    </div>
    <div style="padding-left: 132px;" class="mt-10">
      <div class="d-flex  mb-4">
          <span class="font-weight-bold  text-left mr-6" style="    min-width: 100px;">
             Email
          </span>
        <template v-if="contactAdmin && contactAdmin.email && contactAdmin.email.length">
          <div v-for="email of contactAdmin.email" :key="email">
            {{ email || '' }}
          </div>
        </template>

      </div>
    </div>
    <div style="padding-left: 132px;" class="mt-10">
      <div class="d-flex  mb-4">
          <span class="font-weight-bold  text-left mr-6" style="    min-width: 100px;">
           Phone number
          </span>
        <template v-if="contactAdmin && contactAdmin.phone_number && contactAdmin.phone_number.length">
          <div v-for="phoneNumber of contactAdmin.phone_number" :key="phoneNumber">
            {{ phoneNumber || '' }}
          </div>
        </template>
      </div>
    </div>
  </v-card>
</template>

<script>
import Vue from "vue"
import clientSettingProvider from "@/services/client-setting/defaultDataProvider"

export default Vue.extend({
  name: "Index",
  data() {
    return {
      contactAdmin: {}
    }
  },
  watch: {},
  async mounted() {
    await this.getData()
  },
  methods: {
    async getData() {
      const data = await this.getDataClientSetting();
      if (data && data.settings && data.settings.contact_admins) {
        this.contactAdmin = {
          displayName: data.settings.contact_admins.map(admin => admin.display_name),
          email: data.settings.contact_admins.map(admin => admin.email),
          phone_number: data.settings.contact_admins.map(admin => admin.phone_number),
        }
      } else if (data && data.settings && data.settings.contact_admin) {
        this.contactAdmin = data.settings.contact_admin
      }
    },
    async getDataClientSetting() {
      const dataProvider = clientSettingProvider();
      try {
        const {body} = await dataProvider.execute("SettingGet", {});
        if (body && body.data) {
          return body.data;
        }
      } catch (err) {
        return {};
      }
    },
  },

})
</script>

<style lang="scss">
.text-warning {
  //color: #ffcc00!important;
  font-weight: bold !important;
}
</style>
